var _path, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.20763 4.54199H3.14008L3.08592 4.86694C2.91489 5.89307 3.15697 6.61254 3.61129 7.07114C3.92843 7.39125 4.31886 7.55319 4.66223 7.61798L4.99384 11.9309H4.24711V12.7087H10.4693V11.9309H9.72264L10.0539 7.62696C10.3528 7.58197 10.6115 7.47997 10.8302 7.32905C11.1309 7.1215 11.3304 6.839 11.4583 6.54383C11.7087 5.96604 11.7031 5.30047 11.6309 4.86694L11.5767 4.54199H4.98681C4.96189 4.16076 4.97785 3.70934 5.07964 3.33036C5.14614 3.08275 5.24131 2.89633 5.35701 2.77642C5.46243 2.66715 5.59836 2.59754 5.80267 2.59754V1.81976C5.38475 1.81976 5.04754 1.977 4.79728 2.23637C4.55731 2.48509 4.41429 2.8091 4.32848 3.12862C4.20411 3.59169 4.1832 4.10869 4.20763 4.54199ZM9.27177 7.6531H5.44501L5.77391 11.9309H8.94256L9.27177 7.6531ZM5.02512 6.87532H9.69174C10.0131 6.87532 10.2332 6.79606 10.3884 6.68895C10.5454 6.58053 10.6619 6.42553 10.7446 6.23458C10.867 5.95209 10.9046 5.61488 10.895 5.31976H3.81443C3.77179 5.95429 3.95755 6.31552 4.16383 6.52375C4.42028 6.7826 4.77736 6.87527 5.02512 6.87532C5.02511 6.87532 5.02514 6.87532 5.02512 6.87532Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.15515,
    cy: 2.23306,
    rx: 0.765625,
    ry: 0.65625,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMike);
export default __webpack_public_path__ + "static/media/mike.f94c1331a0b09b4dd5d5ffd339c1d581.svg";
export { ForwardRef as ReactComponent };